import InputType from 'common/form/InputType';
import { Form, Input } from 'decorator-form';

@Form({title: "Programs Config"})
export default class ProgramsConfig {

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

	@Input({type: InputType.CHECKBOX, title: "Show Progress Bar"})
	public showProgress: boolean = true;

}



// WEBPACK FOOTER //
// ./src/panels/programs/ProgramsConfig.ts